"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiscountFromPromoCode = exports.PAYMENT_METHODS = exports.PRICES = exports.PRODUCTS = void 0;
const report_1 = require("../report");
const CA_ADULT_PRICE = 89.95;
const ADULT_TAX_REPORT_TRANSLATIONS = {
    en: 'Tax report for adult',
    fr: 'Déclaration pour adulte',
};
exports.PRODUCTS = {
    report: {
        [report_1.PERSON_TYPES.self]: {
            name: ADULT_TAX_REPORT_TRANSLATIONS,
        },
        [report_1.PERSON_TYPES.partner]: {
            name: ADULT_TAX_REPORT_TRANSLATIONS,
        },
        [report_1.PERSON_TYPES.child]: {
            name: {
                en: 'Tax report for child',
                fr: 'Déclaration pour enfant',
            },
        },
        rentalIncome: {
            name: {
                en: 'Income building',
                fr: 'Immeuble à revenus',
            },
        },
    },
};
const CA_HST_TAX_NAME = {
    id: 'hst',
    name: {
        en: 'HST',
        fr: 'TVH',
    },
};
const CA_GST_TAX_NAME = {
    id: 'gst',
    name: {
        en: 'GST',
        fr: 'TPS',
    },
};
const CA_QST_TAX_NAME = {
    id: 'qst',
    name: {
        en: 'QST',
        fr: 'TVQ',
    },
};
const CA_PST_TAX_NAME = {
    id: 'pst',
    name: {
        en: 'PST',
        fr: 'TVP',
    },
};
exports.PRICES = {
    ca: {
        report: {
            [report_1.PERSON_TYPES.self]: CA_ADULT_PRICE,
            [report_1.PERSON_TYPES.partner]: CA_ADULT_PRICE,
            [report_1.PERSON_TYPES.child]: 39.95,
            selfEmployed: 159.95,
            rentalIncome: 30,
        },
        taxes: {
            /** Alberta */
            [report_1.PROVINCES.ab]: [{ ...CA_GST_TAX_NAME, rate: 0.05 }],
            /** British Columbia */
            [report_1.PROVINCES.bc]: [
                { ...CA_GST_TAX_NAME, rate: 0.05 },
                { ...CA_PST_TAX_NAME, rate: 0.07 },
            ],
            /** Manitoba */
            [report_1.PROVINCES.mb]: [
                { ...CA_GST_TAX_NAME, rate: 0.05 },
                { ...CA_PST_TAX_NAME, rate: 0.07 },
            ],
            /** New Brunswick */
            [report_1.PROVINCES.nb]: [{ ...CA_HST_TAX_NAME, rate: 0.15 }],
            /** Newfoundland and Labrador */
            [report_1.PROVINCES.nl]: [{ ...CA_HST_TAX_NAME, rate: 0.15 }],
            /** Nova Scotia */
            [report_1.PROVINCES.ns]: [{ ...CA_HST_TAX_NAME, rate: 0.14 }],
            /** Northwest Territories */
            [report_1.PROVINCES.nt]: [{ ...CA_GST_TAX_NAME, rate: 0.05 }],
            /** Nunavut */
            [report_1.PROVINCES.nu]: [{ ...CA_GST_TAX_NAME, rate: 0.05 }],
            /** Ontario */
            [report_1.PROVINCES.on]: [{ ...CA_HST_TAX_NAME, rate: 0.13 }],
            /** Prince Edward Island */
            [report_1.PROVINCES.pe]: [{ ...CA_HST_TAX_NAME, rate: 0.15 }],
            /** Quebec */
            [report_1.PROVINCES.qc]: [
                { ...CA_GST_TAX_NAME, rate: 0.05 },
                { ...CA_QST_TAX_NAME, rate: 0.09975 },
            ],
            /** Saskatchewan */
            [report_1.PROVINCES.sk]: [
                { ...CA_GST_TAX_NAME, rate: 0.05 },
                { ...CA_PST_TAX_NAME, rate: 0.06 },
            ],
            /** Yukon */
            [report_1.PROVINCES.yt]: [{ ...CA_GST_TAX_NAME, rate: 0.05 }],
        },
    },
};
var PAYMENT_METHODS;
(function (PAYMENT_METHODS) {
    PAYMENT_METHODS["creditCard"] = "creditCard";
    PAYMENT_METHODS["paypal"] = "paypal";
})(PAYMENT_METHODS = exports.PAYMENT_METHODS || (exports.PAYMENT_METHODS = {}));
function getDiscountFromPromoCode(subtotal, promoCode) {
    if (!subtotal || !promoCode)
        return 0;
    const { amountDiscount, percentageDiscount } = promoCode;
    let discount = 0;
    if (amountDiscount)
        discount = amountDiscount;
    else if (percentageDiscount)
        discount = Math.round(subtotal * percentageDiscount * 100) / 100;
    return discount;
}
exports.getDiscountFromPromoCode = getDiscountFromPromoCode;
//# sourceMappingURL=index.js.map